import { useQuery } from '@apollo/client';
import { GET_STATE_TAX_RATES } from '../graphql/queries/getStateTaxRates';

export interface StateTaxRate {
  stateCode: string;
  individual: number | null;
  cCorp: number | null;
  sCorp: number | null;
  insertDate: Date | null;
  insertUser: string | null;
  modifiedDate: Date | null;
  modifiedUser: string | null;
}

export const useGetStateTaxRates = () => {
  const { data, loading, error } = useQuery<{ stateTaxRates: StateTaxRate[] }>(GET_STATE_TAX_RATES, {
    fetchPolicy: 'cache-first'
  });

  return {
    loading,
    error,
    stateTaxRates: data?.stateTaxRates ?? []
  };
};

